import React, { useEffect, useState } from 'react'
import { MediaDescription, MediaDescriptionProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import * as modelProps from 'models/mediaDescription/mediaDescription-property-definitions';
import utils from 'features/mediaDescription/mediaDescription-util'
import validations from 'features/mediaDescription/mediaDescription-validation'

export interface MediaDescriptionProps {
    BuildList?: (
        page: any,
        name: MediaDescriptionProperties,
        form: MediaDescription,
    ) => JSX.Element[]
    page?: any
    title?: any
    form?: MediaDescription
    onUpdate?: (form: MediaDescription, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function MediaDescriptionForm(props: MediaDescriptionProps) {
    let [form, setForm] = useState({} as MediaDescription)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as MediaDescription)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as MediaDescription)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<MediaDescription, MediaDescriptionProperties> | any =
    {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.MediaDescriptionProperties.Id,
                modelProps.MediaDescriptionProperties.Deleted,
                modelProps.MediaDescriptionProperties.Version,
                modelProps.MediaDescriptionProperties.Created,
                modelProps.MediaDescriptionProperties.Updated,
                modelProps.MediaDescriptionProperties.Owner,
                modelProps.MediaDescriptionProperties.Name,
                modelProps.MediaDescriptionProperties.Description
            ].includes(x.name))
        },
        BuildList: (
            page,
            name: MediaDescriptionProperties,
            form: MediaDescription,
        ) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: MediaDescription,
            property: MediaDescriptionProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: MediaDescriptionProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>
            {BuildForm<MediaDescription, MediaDescriptionProperties>(args)}
        </React.Fragment>
    )
}
